// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23WWM","delete":"styles_delete__daRdu","update":"styles_update__2c-WT","add":"styles_add__1rs02"};